import Icons from './Icons';
import Circle0 from './characterIcons/Circle0';
import Circle1 from './characterIcons/Circle1';
import Circle2 from './characterIcons/Circle2';
import Circle3 from './characterIcons/Circle3';
import Circle4 from './characterIcons/Circle4';
import Circle5 from './characterIcons/Circle5';
import Circle6 from './characterIcons/Circle6';
import Circle7 from './characterIcons/Circle7';
import Circle8 from './characterIcons/Circle8';
import Circle9 from './characterIcons/Circle9';
import CircleA from './characterIcons/CircleA';
import CircleB from './characterIcons/CircleB';
import CircleC from './characterIcons/CircleC';
import CircleD from './characterIcons/CircleD';
import CircleE from './characterIcons/CircleE';
import CircleF from './characterIcons/CircleF';
import CircleG from './characterIcons/CircleG';
import CircleH from './characterIcons/CircleH';
import CircleI from './characterIcons/CircleI';
import CircleJ from './characterIcons/CircleJ';
import CircleK from './characterIcons/CircleK';
import CircleL from './characterIcons/CircleL';
import CircleM from './characterIcons/CircleM';
import CircleN from './characterIcons/CircleN';
import CircleO from './characterIcons/CircleO';
import CircleP from './characterIcons/CircleP';
import CircleQ from './characterIcons/CircleQ';
import CircleR from './characterIcons/CircleR';
import CircleS from './characterIcons/CircleS';
import CircleT from './characterIcons/CircleT';
import CircleU from './characterIcons/CircleU';
import CircleV from './characterIcons/CircleV';
import CircleW from './characterIcons/CircleW';
import CircleX from './characterIcons/CircleX';
import CircleY from './characterIcons/CircleY';
import CircleZ from './characterIcons/CircleZ';

const characterIcons = new Map([
  Circle0,
  Circle1,
  Circle2,
  Circle3,
  Circle4,
  Circle5,
  Circle6,
  Circle7,
  Circle8,
  Circle9,
  CircleA,
  CircleB,
  CircleC,
  CircleD,
  CircleE,
  CircleF,
  CircleG,
  CircleH,
  CircleI,
  CircleJ,
  CircleK,
  CircleL,
  CircleM,
  CircleN,
  CircleO,
  CircleP,
  CircleQ,
  CircleR,
  CircleS,
  CircleT,
  CircleU,
  CircleV,
  CircleW,
  CircleX,
  CircleY,
  CircleZ,
].map(i => [i.iconCharacter, i]));


/**
 * @param {string} iconCharacter
 */
function getCharacterIcon(iconCharacter) {
  const icon = characterIcons.get(iconCharacter);

  if (icon) {
    return icon;
  }

  return Icons.Circle;
}


export default {
  getCharacterIcon,
};
